import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import TextInput from "../../components/forms/TextInput";
import { useAuth } from "../../js/hooks/useAuth";
import { useStore } from "../../js/state/store";
import { changeLocalPassword } from "../../js/auth/authOnboarding";
import { resolvePostAuthPath } from "../../js/auth/onboardingState";

export default function RotatePassword() {
  const { session } = useAuth();
  const { dispatch } = useStore();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");

  if (!session?.must_rotate) {
    navigate(resolvePostAuthPath(session), { replace: true });
    return null;
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (password.length < 8) {
      setMessage("Use at least 8 characters.");
      return;
    }
    if (password !== confirm) {
      setMessage("Passwords do not match.");
      return;
    }
    const next = changeLocalPassword(session.userId, password, { clearRotate: true });
    if (next) dispatch({ type: "SET_SESSION", payload: next });
    navigate(resolvePostAuthPath(next || { ...session, must_rotate: false }), { replace: true });
  }

  return (
    <AppLayout>
      <article className="card auth-card onboarding-card">
        <h1>Create a new password</h1>
        <p className="page-lead">
          Your account requires a password change before the desk opens. Choose something you have
          not used here before.
        </p>
        <form onSubmit={handleSubmit}>
          <TextInput
            label="New password"
            name="password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="new-password"
          />
          <TextInput
            label="Confirm password"
            name="confirm"
            type="password"
            value={confirm}
            onChange={(event) => setConfirm(event.target.value)}
            autoComplete="new-password"
          />
          {message ? <p className="field-error">{message}</p> : null}
          <button type="submit" className="primary-btn btn-block">
            Update password
          </button>
        </form>
      </article>
    </AppLayout>
  );
}
